module.exports = __webpack_public_path__ + "img/(10).c411dc9c.jpg";